import { atom } from 'recoil';

export const startCardAnimationState = atom({
  key: 'startCardAnimation',
  default: false,
});